export var GashTransactionType;
(function (GashTransactionType) {
    GashTransactionType["GASH_STORE_REDEEM"] = "gash_store_redeem";
    GashTransactionType["TRANSFER_TO_GA"] = "transfer_to_ga";
    GashTransactionType["SYSTEM_DEPOSIT"] = "system_deposit";
    GashTransactionType["ACTIVITY"] = "activity";
    GashTransactionType["GIFT"] = "gift";
    GashTransactionType["GRANT_BY_ADMIN"] = "grant_by_admin";
    GashTransactionType["RECLAIM_BY_ADMIN"] = "reclaim_by_admin";
})(GashTransactionType || (GashTransactionType = {}));
//# sourceMappingURL=GashTransactionType.js.map